import { createFileRoute } from '@tanstack/react-router'
import i18next from 'i18next'
import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import Kiosk from '@/components/organisms/kiosk'
import { translations } from '@/i18n'

export const Route = createFileRoute('/kiosk/')({
  component: KioskRoute,
})

// Swap the app manifest for the kiosk one so "Add to Home Screen" on the iPad opens /kiosk
// standalone in landscape instead of the Flow app.
const useKioskManifest = () => {
  useEffect(() => {
    const links = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="manifest"]'))
    const previous = links.map(link => link.getAttribute('href'))
    for (const link of links) link.setAttribute('href', '/kiosk.webmanifest')
    return () => {
      links.forEach((link, index) => {
        const href = previous[index]
        if (href) link.setAttribute('href', href)
      })
    }
  }, [])
}

// The kiosk is a shared workshop device with no signed-in user, so it can't follow a user's
// language setting. Pin it to Swedish with a standalone instance (no browser detector), so the
// iPad's system language doesn't decide the UI and Flow's cached language choice is untouched.
const kioskI18n = i18next.createInstance()
kioskI18n.init({
  lng: 'sv',
  fallbackLng: 'sv',
  resources: { sv: { translation: translations.sv } },
  interpolation: { escapeValue: false },
  initAsync: false,
})

function KioskRoute() {
  useKioskManifest()
  return (
    <I18nextProvider i18n={kioskI18n}>
      <Kiosk />
    </I18nextProvider>
  )
}
